<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/label/raw/materials/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('biaoqiantiaomahao')">
            <el-input v-model="yt.conditions.barCode"></el-input>
          </el-form-item>
          <el-form-item  :label="$t('wuliaomingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('picihao')">
            <el-input v-model="yt.conditions.batchNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>


    </yi_curd_table>


  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_base_label_management_label_raw_materials',
  components: {
  },
  data() {
    return {
      columns: [
        {
          label: 'biaoqiantiaomahao',
          prop: 'barCode',
          width: 120
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code',
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
        },
        {
          label: 'guige',
          prop: 'material.spec',
        },
        {
          label: 'shuliang',
          prop: 'quantity',
        },
        {
          label: 'yitouliaoshuliang',
          prop: 'feedingWeight',
        },
        {
          label: 'picihao',
          prop: 'batchNumber',
        },
        {
          label: 'jihuadanhao',
          prop: 'planNo',
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpOrderNo',
          width: 120
        },
        {
          label: 'erpgongdanhanghao',
          prop: 'erpOrderLineNo',
          width: 120
        },
        {
          label: 'gongyingshangbianma',
          prop: 'supplierCode',
          width: 120
        },
        {
          label: 'shengchanriqi',
          prop: 'productionDate',
          type: 'time',
          width: 180
        },
        {
          label: 'wuliaoyouxiaoqi',
          prop: 'effectiveDate',
          type: 'time',
          width: 180
        },
        {
          label: 'faliaodanhao',
          prop: 'materialIssueNo',
        },
        {
          label: 'faliaoxiangci',
          prop: 'materialIssueCount',
        },
        {
          label: 'faliaoshijian',
          prop: 'materialIssueDate',
          type: 'time',
          width: 180
        },

        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'id desc',
      }
      console.log(this.yt.get(1));
      this.yt.get(1);

    }, 300);
  },
  methods: {



  }
};
</script>
